// Accessing `window.localStorage` can THROW (not just return null) when the
// browser blocks site data — "block all cookies", some incognito/partitioned
// contexts, or an exceeded quota. These wrappers swallow that so callers can
// degrade gracefully instead of crashing bootstrap or hanging the login flow.

export function isStorageAvailable(): boolean {
  try {
    const probe = '__cc_storage_probe__';
    window.localStorage.setItem(probe, probe);
    window.localStorage.removeItem(probe);
    return true;
  } catch {
    return false;
  }
}

export function safeStorageGet(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeStorageSet(key: string, value: string): boolean {
  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

export function safeStorageRemove(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch {
    // storage unavailable — nothing to remove
  }
}

export function safeStorageClear(): void {
  try {
    window.localStorage.clear();
  } catch {
    // storage unavailable — nothing to clear
  }
}
